import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PostOrderAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { PostUserAdmin, PutUserAdmin } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useUpdateUserAdmin(props: { reload?: () => void; id: string }) {
	const { openAlertDialog } = useAlertDialog();
	const updateUserAd = async (
		name: string,
		email: string,
		phone: string,
		pass: string,
		selectedCountryCode: string,
		type: string
	) => {
		try {
			await PutUserAdmin(props.id, name, email, phone, pass, selectedCountryCode, type);
			openAlertDialog?.(AlertType.Success, "Update Successfully!", () => {
				props.reload?.();
			});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "Fail!");
		}
	};

	return {
		updateUserAd,
	};
}
